module.exports = __webpack_public_path__ + "static/img/app1.9b0fd67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app1.jpg
// module id = FIrF
// module chunks = 1